import styled from 'styled-components';

import { colorsPalettes, setFontVariant } from '@similarweb/styles';

import { Dropdown } from '../../../../../components/Dropdown';
import { StyledDropdownOption } from '../../../../../components/Dropdown/styles';

export const StyledAccountDropdownContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const StyledAccountDropdown = styled(Dropdown)`
  bottom: 41px;
  right: 0;
  left: unset;
  width: 320px;
`;

export const StyledAccountOption = styled(StyledDropdownOption)`
  gap: 6px;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
`;

export const StyledAccountOptionHeaded = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 6px;
  width: 100%;
`;

export const StyledAccountOptionInfo = styled.div`
  ${setFontVariant('listItem3', colorsPalettes.carbon[300])};
  width: 100%;
  text-align: left;
`;

export const StyledAccountOptionCount = styled.div`
  ${setFontVariant('input2', colorsPalettes.carbon[300])};
`;

export const StyledAccountName = styled.span`
  ${setFontVariant('input2', colorsPalettes.carbon[500])};
  flex-shrink: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledTaskCount = styled.span`
  flex-shrink: 0;
  margin-left: auto;
  ${setFontVariant('caption', colorsPalettes.carbon[250])};
`;
